<h1 class="page-title">{{ 'account.sections.badges' | t }}</h1>

@if (loading) {
  <p class="muted">{{ 'account.loading' | t }}</p>
} @else if (error) {
  <p class="error-text">{{error}}</p>
  <button type="button" class="btn-pill btn-pill-outline" (click)="load()">{{ 'account.retry' | t }}</button>
} @else {
  <div class="badges-head">
    <p class="muted">{{ 'club.badges.intro' | t }}</p>
    <strong>{{ 'club.badges.count' | t: { unlocked: unlockedCount, total: badges.length } }}</strong>
  </div>

  <div class="tabs" role="tablist">
    <button type="button" class="tab" [class.active]="filter === 'all'" (click)="filter = 'all'">{{ 'club.badges.filterAll' | t }}</button>
    <button type="button" class="tab" [class.active]="filter === 'unlocked'" (click)="filter = 'unlocked'">{{ 'club.badges.unlocked' | t }}</button>
    <button type="button" class="tab" [class.active]="filter === 'inProgress'" (click)="filter = 'inProgress'">{{ 'club.badges.inProgress' | t }}</button>
  </div>

  <ul class="badge-list">
    @for (badge of visibleBadges; track badge.id) {
      <li class="badge" [class.unlocked]="badge.unlocked" [class.locked]="badge.locked">
        <span class="badge-icon"><mat-icon>{{ badge.locked ? 'lock' : badge.icon }}</mat-icon></span>
        <div class="badge-body">
          <div class="badge-head">
            <strong>{{ 'club.badges.items.' + badge.id + '.name' | t }}</strong>
            @if (badge.unlocked) {
              <span class="chip approved"><mat-icon>check</mat-icon>{{ 'club.badges.unlocked' | t }}</span>
            } @else if (badge.locked) {
              <span class="chip">{{ 'club.badges.locked' | t }}</span>
            } @else {
              <span class="count">{{badge.value}}/{{badge.threshold}}</span>
            }
          </div>
          @if (badge.locked && badge.requires) {
            <p class="muted">{{ 'club.badges.lockedHint' | t: { name: ('club.badges.items.' + badge.requires + '.name' | t) } }}</p>
          } @else {
            <p class="muted">{{ 'club.badges.items.' + badge.id + '.desc' | t: { count: badge.threshold } }}</p>
            @if (!badge.unlocked) {
              <div class="progress"><span [style.width.%]="progress(badge)"></span></div>
            }
          }
        </div>
      </li>
    } @empty {
      <li class="muted">{{ 'club.badges.none' | t }}</li>
    }
  </ul>
}
